import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.sass']
})
export class ButtonsPaletteComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
